/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Splits, SplitsInterface } from "../Splits";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
      {
        internalType: "address[]",
        name: "payees",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "shares_",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ERC20PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "payeeCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_URI",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type SplitsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SplitsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Splits__factory extends ContractFactory {
  constructor(...args: SplitsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    _trustedForwarder: string,
    _uri: string,
    payees: string[],
    shares_: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Splits> {
    return super.deploy(
      _controlCenter,
      _trustedForwarder,
      _uri,
      payees,
      shares_,
      overrides || {}
    ) as Promise<Splits>;
  }
  getDeployTransaction(
    _controlCenter: string,
    _trustedForwarder: string,
    _uri: string,
    payees: string[],
    shares_: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenter,
      _trustedForwarder,
      _uri,
      payees,
      shares_,
      overrides || {}
    );
  }
  attach(address: string): Splits {
    return super.attach(address) as Splits;
  }
  connect(signer: Signer): Splits__factory {
    return super.connect(signer) as Splits__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SplitsInterface {
    return new utils.Interface(_abi) as SplitsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Splits {
    return new Contract(address, _abi, signerOrProvider) as Splits;
  }
}
